module.exports = __webpack_public_path__ + "static/media/154-guinea.fadf8e08.svg";